export const users = {
  description: "Shop accounts. Operators cannot see commercial or money data.",
  addUser: "Add user",
  caption: "Shop users",
  emptyTitle: "No users",
  emptyDescription: "Seeded demo accounts should appear here.",
  column: {
    user: "User",
    lastSignIn: "Last sign-in",
    manage: "Manage",
  },
  role: "Role",
  roleFor: "Role for {name}",
  active: "Active",
  inactive: "Inactive",
  create: {
    title: "Add a shop user",
    description: "The person signs in with this email and the initial password you set.",
    submit: "Create user",
    fullName: "Full name",
    initialPassword: "Initial password",
    passwordHint: "At least 10 characters with upper, lower, and a digit.",
    createdToast: "User created",
    createdToastDesc: "{name} can now sign in.",
  },
  roleUpdated: "Role updated",
  roleUpdatedDesc: "{name} is now {role}.",
  activatedToast: "User activated",
  deactivatedToast: "User deactivated",
  deactivatedDesc: "Their open sessions were revoked.",
  activate: "Activate",
  deactivate: "Deactivate",
  activateTitle: "Activate {name}?",
  deactivateTitle: "Deactivate {name}?",
  deactivateDescription:
    "Deactivation revokes all open sessions immediately. The audit trail keeps the reason.",
  reasonHint: "Required (minimum 3 characters).",
};
